<template>
  <div :class="cardStyles" class="mb-8 p-6 duration-300" id="container">
    <!-- <pre>{{ item }}</pre> -->
    <div class="md:flex">
      <div class="md:w-4/12 flex items-end">
        <img :alt="item.VehicleGroup.ShortDescription" class="rounded-lg mr-4" style="width: 300px;height: auto"
          :src="item.VehicleGroup.ImageURL" />
      </div>
      <!-- title  -->
      <div class="md:w-5/12">
        <h4 class="text-lg font-bold py-4">
          {{ item.VehicleGroup.ShortDescription }}
        </h4>

        <div class="grid col-span-2" style="display: grid; grid-template-columns: auto auto">
          <div class="flex p-1" v-if="item.VehicleGroup.Passengers">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 24 24">
              <path
                d="M16.5 6a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M18 6A6 6 0 1 0 6 6a6 6 0 0 0 12 0M3 23.25a9 9 0 1 1 18 0 .75.75 0 0 0 1.5 0c0-5.799-4.701-10.5-10.5-10.5S1.5 17.451 1.5 23.25a.75.75 0 0 0 1.5 0">
              </path>
            </svg>
            <p>{{ item.VehicleGroup.Passengers }} seats</p>
          </div>

          <div class="flex p-1" v-if="item.VehicleGroup.Transmition">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 24 24">
              <path
                d="M19.25 14.25v-4.5l-1.374.416 3 4.5c.412.617 1.374.326 1.374-.416v-4.5a.75.75 0 0 0-1.5 0v4.5l1.374-.416-3-4.5c-.412-.617-1.374-.326-1.374.416v4.5a.75.75 0 0 0 1.5 0m3 6a3.75 3.75 0 0 0-3.75-3.75.75.75 0 0 0-.75.75v6c0 .414.336.75.75.75a3.75 3.75 0 0 0 3.75-3.75m-1.5 0a2.25 2.25 0 0 1-2.25 2.25l.75.75v-6l-.75.75a2.25 2.25 0 0 1 2.25 2.25M18.5 4.5H20A2.25 2.25 0 0 0 20 0h-1.5a.75.75 0 0 0-.75.75v6a.75.75 0 0 0 1.5 0v-6l-.75.75H20A.75.75 0 0 1 20 3h-1.5a.75.75 0 0 0 0 1.5M4.25 6.75v4.5A2.25 2.25 0 0 0 6.5 13.5H8a.75.75 0 0 1 .75.75v4.5A2.25 2.25 0 0 0 11 21h3a.75.75 0 0 0 0-1.5h-3a.75.75 0 0 1-.75-.75v-4.5A2.25 2.25 0 0 0 8 12H6.5a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 0-1.5 0m3-3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0m1.5 0a3.75 3.75 0 1 0-7.5 0 3.75 3.75 0 0 0 7.5 0">
              </path>
            </svg>
            <p>{{ item.VehicleGroup.Transmition }}</p>
          </div>

          <div class="flex p-1" v-if="item.VehicleGroup.Luggages">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 24 24">
              <path
                d="M22.5 14.249v4.5a2.25 2.25 0 0 1-2.25 2.25H3.75a2.25 2.25 0 0 1-2.25-2.25v-9a2.25 2.25 0 0 1 2.25-2.25h16.5a2.25 2.25 0 0 1 2.25 2.25zm1.5 0v-4.5a3.75 3.75 0 0 0-3.75-3.75H3.75A3.75 3.75 0 0 0 0 9.749v9a3.75 3.75 0 0 0 3.75 3.75h16.5a3.75 3.75 0 0 0 3.75-3.75zm-18-7.5v15a.75.75 0 0 0 1.5 0v-15a.75.75 0 0 0-1.5 0m10.5 0v15a.75.75 0 0 0 1.5 0v-15a.75.75 0 0 0-1.5 0m0 0v-3a2.25 2.25 0 0 0-2.25-2.25h-4.5a2.25 2.25 0 0 0-2.25 2.25v3a.75.75 0 0 0 1.5 0v-3a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v3a.75.75 0 0 0 1.5 0">
              </path>
            </svg>
            <p>{{ item.VehicleGroup.Luggages }} Large Bag</p>
          </div>

          <div class="flex p-1" v-if="item.VehicleGroup.SmallLuggages">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 24 24">
              <path
                d="M15 14.75H9a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 0 1.5m.75 3.25a.76.76 0 0 0-.75-.75H9a.75.75 0 0 0 0 1.5h6a.76.76 0 0 0 .75-.75m3-6.5v9a2.25 2.25 0 0 1-2.25 2.25h-.75v.5a.75.75 0 0 1-1.5 0v-.5h-4.5v.5a.75.75 0 0 1-1.5 0v-.5H7.5a2.25 2.25 0 0 1-2.25-2.25v-9A2.25 2.25 0 0 1 7.5 9.25h1.75v-8C9.25.56 9.81 0 10.5 0h3c.69 0 1.25.56 1.25 1.25v8h1.75a2.25 2.25 0 0 1 2.25 2.25m-8-2.25h2.5V1.5h-2.5zm6.5 2.25a.76.76 0 0 0-.75-.75h-9a.76.76 0 0 0-.75.75v9a.76.76 0 0 0 .75.75h9a.76.76 0 0 0 .75-.75z">
              </path>
            </svg>
            <p>{{ item.VehicleGroup.SmallLuggages }} Small bag</p>
          </div>

          <div class="flex p-1">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 24 24">
              <path
                d="M9.75 15.292v-.285a2.25 2.25 0 0 1 4.5 0v.285a.75.75 0 0 0 1.5 0v-.285a3.75 3.75 0 1 0-7.5 0v.285a.75.75 0 0 0 1.5 0M13.54 5.02l-2.25 6.75a.75.75 0 0 0 1.424.474l2.25-6.75a.75.75 0 1 0-1.424-.474M6.377 6.757a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25.75.75 0 0 0 0 1.5.375.375 0 1 1 0-.75.375.375 0 0 1 0 .75.75.75 0 0 0 0-1.5m12.75 3.75a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25.75.75 0 0 0 0 1.5.375.375 0 1 1 0-.75.375.375 0 0 1 0 .75.75.75 0 0 0 0-1.5m-1.496-3.75a1.125 1.125 0 1 0 1.119 1.131v-.006c0-.621-.504-1.125-1.125-1.125a.75.75 0 0 0 0 1.5.375.375 0 0 1-.375-.375V7.88a.375.375 0 1 1 .373.377.75.75 0 1 0 .008-1.5m-8.254-3a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25.75.75 0 0 0 0 1.5.375.375 0 1 1 0-.75.375.375 0 0 1 0 .75.75.75 0 0 0 0-1.5M21.88 17.541a16.5 16.5 0 0 0-19.76 0 .75.75 0 1 0 .898 1.202 15 15 0 0 1 17.964 0 .75.75 0 1 0 .898-1.202m.62-5.534c0 5.799-4.701 10.5-10.5 10.5s-10.5-4.701-10.5-10.5 4.701-10.5 10.5-10.5 10.5 4.701 10.5 10.5m1.5 0c0-6.627-5.373-12-12-12s-12 5.373-12 12 5.373 12 12 12 12-5.373 12-12m-19.123-1.5a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25.75.75 0 0 0 0 1.5.375.375 0 1 1 0-.75.375.375 0 0 1 0 .75.75.75 0 0 0 0-1.5">
              </path>
            </svg>
            <p>Unlimited Mileage</p>
          </div>
        </div>
      </div>
      <div v-if="showButtonAndPrice" class="flex flex-col md:w-3/12 text-right align-bottom">
        <!-- This div to take place  -->
        <div class="flex-grow"></div>
        <!-- <span class="text-footerColor">{{ priceFor3Days }}</span> -->

        <h3 class="font-bold text-right">
          RM {{ item.Charges.Calculation.UnitAmount }}
        </h3>
        <p class="hidden md:flex justify-end text-green-700 text-sm">
          Free Cancellation
        </p>
        <vs-button @click="handelViewDeal(item)" class="mt-2" color="green">Select</vs-button>
      </div>
    </div>

    <!-- <div>
    <vs-divider />
    <div>reviews here</div>
  </div> -->
  </div>
</template>

<script>
import { axiosMixin } from "@/mixin/axiosMixin";
export default {
  mixins: [axiosMixin],
  props: {
    item: {
      required: true,
    },
    showButtonAndPrice: {
      type: Boolean,
      default: false,
    },
    cardStyles: {
      type: String,
      default: "bg-white rounded-lg shadow hover:shadow-lg",
    },
  },
  computed: {},
  methods: {
    startLoading() {
      this.$vs.loading({
        container: '#container',
        scale: 0.6
      });
    },
    stopLoading() {
      this.$vs.loading.close('#container > .con-vs-loading');
    },
    handelViewDeal(carDetails) {
      console.log('car details:', carDetails);
      console.log('booking details:', this.$store.state.main.bookingDetails);


      this.startLoading();
      var params = {
        dateFrom: this.$store.state.main.bookingDetails.formData.pickupDate,
        dateTo: this.$store.state.main.bookingDetails.formData.dropoffDate,
        pickupplace: this.$store.state.main.bookingDetails.formData.pickupPlace,
        dropoffplace: this.$store.state.main.bookingDetails.formData.dropOffPlace,
        vehiclegroup: carDetails.VehicleGroup.Group,
        pm: 'local'
      }
      this.aronPost('getExtras', params, '', '')
        .then(response => {
          if (response.status) {
            var extras = response.data.extras;
            for (let i = 0; i < extras.length; i++) {
              extras[i].Quantity = 0;
            }
            this.$store.state.main.extras = extras;
            this.$store.state.main.currentCarSelected = carDetails;
            this.$router.push("/carDetails").catch(() => { });
          } else {
            this.errorAlert('Error', response.data.error);
          }

          this.stopLoading();
        })
        .catch(error => {
          console.log('error:', error);
          this.stopLoading();
        });

      // this.$store.state.main.currentCarSelected = carDetails;
      // this.$router.push("/carDetails").catch(() => { });
    },
  },
};
</script>

<style scoped></style>
